import React, { Fragment, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux';
import { pageTitle } from '../../../../store/softSlice';
import { Grid } from '@mui/material';
import LibraryFilterFormView from '../../../../components/library/report/library_count_rpt/LibraryFilterFormView';
import LibraryFilterListView from '../../../../components/library/report/library_count_rpt/LibraryFilterListView';
import { fetchDataFromApi } from '../../../../widgets/api';
import AppURL from '../../../../widgets/AppURL';
import LibrarySearchReport from '../../../../components/library/report/book_report_name/BookReportsListView';

const LibraryCountTotalReportCreateListView = ({PageTitle, setIconsButton}) => {
     const dispatch = useDispatch();
     const [onBookList, setOnBookList] = useState([]);
    useEffect(() => {
        dispatch(pageTitle({ "title": PageTitle }))
        document.title = `${PageTitle}`;
        setIconsButton(null)
    }, []);
     const [onLibraryOptions, setOnLibraryOptions] = useState([]);
        const fetchLibrarySearchRptList = async()=>{
            try{
                await fetchDataFromApi(AppURL.LibraryURL+"library-book-count-report-options-list-view/").then((res)=>{
                    setOnLibraryOptions(res);
                });
            }catch(error){
                console.log(error);
            }
        }
        useEffect(()=>{
            fetchLibrarySearchRptList();
        },[])
  return (
    <Fragment>
        <Grid container spacing={1}>
            <Grid item sm={12} md={12} xl={12}>
                <LibraryFilterFormView onLibraryOptions={onLibraryOptions} setOnBookList={setOnBookList} />
            </Grid>
            <Grid item sm={12} md={12} xl={12}>
                <LibraryFilterListView onBookList={onBookList} setOnBookList={setOnBookList} />
            </Grid>
        </Grid>
    </Fragment>
  )
}

export default LibraryCountTotalReportCreateListView